import React, { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { Controller, useForm } from "react-hook-form";
import { DatePicker } from "rsuite";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { formatAmount } from "../../../utility/CommonFunctions";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import moment from "moment";
import { Spinner } from "reactstrap";
import SearchSelectBox from "../../../components/comman/SearchSelectBox";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import FileUploader from "./FileUploader";
import PlusIcon from "../../../components/Icons/PlusIcon";
import SearchSelectInput from "../../../components/comman/SearchSelectInput";
import { errorTypes } from "../../../utility/InputValidation";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const createNewExpenseSection = () => ({
  expenseHeadId: "",
  name: "",
  items: [],
  itemsList: [],
});

const createNewItem = () => ({
  itemId: "",
  name: "",
  hsnCode: "",
  quantity: "",
  availableQty: 0,
  rate: "", // This will display the FIXED Unit Rate (disabled input)
  gst: "",
  taxableAmount: "", // This is now the editable input (Base Amount)
});

export default function CreateAgainstPO() {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingExpenseSections, setIsLoadingExpenseSections] =
    useState(false);
  const location = useLocation();
  const [errorState, setErrorState] = useState("");
  const userDetails = useSelector((state) => state.root.userDetails);

  const [expenseSections, setExpenseSections] = useState([]);
  const [expenseHeadList, setExpenseHeadList] = useState([]);
  const [state, setState] = useState({
    vendorList: [],
    purchaseList: [],
    siteId: "",
    siteName: "",
    purchaseId: "",
    purchaseLoading: false,
    isLoadingSite: false,
    expenseHeadItems: [],
    EditData: null,
    purchaseDetails: {},
    paymentTicketDetail: [],
    OandMSites: [],
    projectSites: [],
    assignedSites: [],
    gtc: [],
    financialYear: "--",
  });

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    control,
  } = useForm();

  useEffect(() => {
    if (location?.state?.data) {
      let options = {
        method: "GET",
      };
      let API =
        apiUrl?.get_payment_ticket_details +
        `paymentTicketId=${location?.state?.data?.id}`;
      setState((prev) => ({
        ...prev,
        ptDataLoading: true,
      }));
      callApi(API, options).then((response) => {
        setState((prev) => ({
          ...prev,
          ptDataLoading: false,
        }));
        if (response?.status === true) {
          setState((prev) => ({
            ...prev,
            paymentTicketDetail: response?.data,
          }));
        }
      });
    }
  }, [location?.state?.data]);

  // console.log(state.paymentTicketDetail);

  useEffect(() => {
    if (userDetails?.type === 2) {
      GetAllSitesList();
    } else {
      getAssignedSites();
    }
  }, [userDetails?.type]);

  const handleSearchChange = (data, type) => {
    if (!data) {
      setExpenseHeadList([]);
      setExpenseSections([]);
      setValue("vendorId", "");
      setValue("gstType", "");
      setState((prev) => ({
        ...prev,
        purchaseId: "",
        purchaseDetails: {},
        gtc: [],
        financialYear: "--",
      }));
      return;
    }
    let API = apiUrl?.get_purchase_detail + `purchaseId=${data?.value}`;
    setIsLoadingExpenseSections(true);
    callApi(API).then((response) => {
      setIsLoadingExpenseSections(false);
      if (response?.status) {
        // console.log(response);
        const expenseHeads =
          response?.data?.purchaserequest?.purchaserequestexpenseheads || [];
        setExpenseHeadList(expenseHeads);
        setExpenseSections([createNewExpenseSection()]);

        setState((prev) => {
          const parsedGTC = JSON.parse(response?.data?.gtc || "[]");
          return {
            ...prev,
            purchaseId: data?.value,
            purchaseDetails: response?.data,
            gtc: parsedGTC.map((doc) => ({
              label: `${doc}`,
              inputId: `${doc}`,
              file: "",
              existingId: null,
            })),
            financialYear: response?.data?.financialYear || "--",
          };
        });
        setValue("vendorId", response?.data?.vendor?.name);
        setValue("gstType", response?.data?.gstType || "--");
        setErrorState(data ? "" : "This field is Required");
      }
    });
  };

  useEffect(() => {
    if (state?.paymentTicketDetail) {
      const paymentTicket = state.paymentTicketDetail;

      const restoredSections = paymentTicket?.paymentticketexpenseheads?.map(
        (expense) => ({
          expenseHeadId: expense?.expenseHeadId,
          name: expense?.expensehead?.name,
          itemsList: [],
          items: expense?.paymentticketitems?.map((item) => {
            return {
              itemId: item?.itemId,
              name: item?.item?.name,
              quantity: item?.quantity,
              rate: item?.rate,
              gst: item?.gst,
              taxableAmount: item?.taxableAmount,
              hsnCode: item?.item?.hsnCode,
              availableQty: item?.quantity,
            };
          }),
        })
      );
      setExpenseSections(restoredSections || []);

      setState((pre) => ({
        ...pre,
        siteId: paymentTicket?.site?.id,
        siteName: paymentTicket?.site?.name,
        purchaseId: paymentTicket?.purchaseId,
      }));
      setValue("content", paymentTicket?.description || "");
      setValue("siteId", paymentTicket?.site?.id);
      setValue("expenseMonth", paymentTicket?.expenseMonth || "");
    }
  }, [state?.paymentTicketDetail, setValue]);

  const getAssignedSites = (inputValue = null) => {
    const option = {
      method: "GET",
    };
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    const url = `${apiUrl?.get_user_site}${inputValue ? `?search=${inputValue}` : ""
      }`;
    callApi(url, option).then((res) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (res?.status === true) {
        setState((prev) => ({
          ...prev,
          assignedSites: res?.data?.site?.map((item) => ({
            ...item,
            label: item?.site?.name,
            value: item?.site?.id,
          })),
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const GetAllSitesList = (inputValue = null) => {
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_site +
      `?type=site${inputValue ? `&search=${inputValue}` : ""}`;
    callApi(API, options).then((response) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (response?.status === true) {
        setState((prev) => ({
          ...prev,
          OandMSites: response?.data?.site
            ?.filter((item) => item?.type === "O&M")
            ?.map((item) => ({
              ...item,
              label: item?.site?.name,
              value: item?.site?.id,
            })),
          projectSites: response?.data?.site
            ?.filter((item) => item?.type === "project")
            ?.map((item) => ({
              ...item,
              label: item?.site?.name,
              value: item?.site?.id,
            })),
        }));
      }
    });
  };

  const fetchPurchaseOrderList = (inputValue) => {
    return new Promise((resolve) => {
      const site = state?.siteId || "";
      let API = `${apiUrl.get_purchase}status=approved&siteId=${site}${inputValue ? `&search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };

      setState((prev) => ({
        ...prev,
        purchaseLoading: true,
      }));

      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.purchase.map((purchase) => ({
              value: purchase.id,
              label: purchase.purchaseNumber,
            }));

            setState((prev) => ({
              ...prev,
              purchaseLoading: false,
              purchaseList: response?.data?.purchase,
            }));

            let API =
              apiUrl?.get_purchase_detail +
              `purchaseId=${location?.state?.data?.purchaseId}`;

            if (location?.state?.data) {
              callApi(API).then((res) => {
                if (res?.status) {
                  setState((prev) => ({
                    ...prev,
                    purchaseLoading: false,
                    purchaseList: response?.data?.purchase,
                    purchaseDetails: res?.data,
                    financialYear: res?.data?.financialYear || "--",
                  }));

                  setValue("vendorId", res?.data?.vendor?.name);
                  setValue("gstType", res?.data?.gstType);

                  setExpenseHeadList(
                    res?.data?.purchaserequest?.purchaserequestexpenseheads ||
                    []
                  );

                  setExpenseSections((prevSections) =>
                    prevSections.map((section) => {
                      const matchingHead =
                        res?.data?.purchaserequest?.purchaserequestexpenseheads.find(
                          (h) => h?.expensehead?.id === section.expenseHeadId
                        );
                      return {
                        ...section,
                        itemsList: matchingHead?.supplyrequestitems || [],
                      };
                    })
                  );

                  setState((prev) => {
                    const parsedGTC = state?.paymentTicketDetail?.documents;
                    return {
                      ...prev,
                      gtc: parsedGTC.map((doc) => ({
                        label: `${doc?.name}`,
                        inputId: `${doc?.name}`,
                        file: doc,
                        existingId: doc?.id,
                      })),
                    };
                  });
                }
              });
            }

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const onSubmit = (data) => {
    const hasItems = expenseSections.some(
      (section) => section.items.length > 0
    );
    if (!hasItems) {
      return toast.info("Please add at least one material item");
    }

    // Grand Total is now calculated from Taxable Amount + GST
    const grandTotal = parseFloat(calculateGrandTotal()?.toFixed(2));

    const remaining = Number(state?.purchaseDetails?.remainingAmount || 0);
    const grand = Number(grandTotal || 0);

    const roundedRemaining = Math.round(remaining * 100) / 100;
    const roundedGrand = Math.round(grand * 100) / 100;

    if (
      state?.purchaseDetails?.remainingAmount !== null &&
      roundedGrand > roundedRemaining
    ) {
      return toast.info(
        <>
          Grand Total is exceeding the Approved PO amount. <br />
          The Approved PO Amount is {formatAmount(roundedRemaining)}
        </>
      );
    }

    const paymentTicketExpenseHead = expenseSections
      .filter((section) => section.items.length > 0)
      .map((section) => ({
        expenseHeadId: section.expenseHeadId,
        name: section.name,

        paymentTicketItem: section.items.map((item) => {
          // Find the original item details to get the actual rate
          const originalItem = section.itemsList.find(
            (i) => i?.itemId === item.itemId
          );
          const actualRate = parseFloat(originalItem?.rate || 0);

          return {
            itemId: item.itemId,
            name: item.name,
            quantity: item.quantity,
            rate: actualRate, // Send the actual unit rate to the API
            gst: item.gst || 0,
            taxableAmount: item.taxableAmount, // Send the base amount (Qty * Rate) to the API
          };
        }),
      }));

    const postData = {
      type: "AgainstPO",
      date: data?.date,
      expenseMonth: data?.expenseMonth,
      totalAmount: grandTotal,
      gstType: data?.gstType,
      description: data?.content,
      paymentTicketExpenseHead: JSON.stringify(paymentTicketExpenseHead),
      siteId: state?.siteId,
      purchaseId: state?.purchaseId,
    };

    const formData = new FormData();

    Object.entries(postData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    let allFilesUploaded = true;
    for (let fileObj of state?.gtc || []) {
      // console.log("fileObj------->>", fileObj);
      if (!fileObj?.file) {
        toast.error(`Please upload ${fileObj?.label}`);
        allFilesUploaded = false;
        break;
      }
      if (!fileObj?.existingId) {
        let payloadLabel = fileObj?.label;
        if (payloadLabel === "Invoice") {
          payloadLabel = "Inv";
          // console.log("payloadLabel------->>", payloadLabel);
        }
        formData.append(payloadLabel, fileObj.file); ``
      }
    }

    if (!allFilesUploaded) return;

    const option = {
      method: "POST",
      form_data: formData,
    };

    setIsLoading(true);
    const url = location?.state?.data
      ? apiUrl.update_payment_ticket +
      `?paymentTicketId=${location?.state?.data?.id}`
      : apiUrl.create_payment_ticket;

    callApi(url, option).then((res) => {
      setIsLoading(false);
      if (res?.status) {
        toast.success(res?.message);
        navigate(-1);
      } else {
        toast.error(res?.message);
      }
    });
  };

  const calculateGrandTotal = () => {
    return expenseSections.reduce((total, expense) => {
      return (
        total +
        expense.items.reduce((sum, item) => {
          const taxableAmount = parseFloat(item.taxableAmount || 0);
          const gst = parseFloat(item.gst || 0);
          // Calculate Total Amount (Taxable Amount + GST)
          return sum + taxableAmount * (1 + gst / 100);
        }, 0)
      );
    }, 0);
  };

  const addExpenseSection = () => {
    setExpenseSections((prev) => [...prev, createNewExpenseSection()]);
  };

  const removeExpenseSection = (expenseIndex) => {
    setExpenseSections((prev) => prev.filter((_, i) => i !== expenseIndex));
  };

  const handleExpenseHeadChange = (expenseIndex, e) => {
    const newExpenseHeadId = e.target.value;
    const selectedHead = expenseHeadList.find(
      (head) => head?.expensehead?.id === newExpenseHeadId
    );

    setExpenseSections((prev) =>
      prev.map((section, i) => {
        if (i === expenseIndex) {
          return {
            ...section,
            expenseHeadId: newExpenseHeadId,
            name: selectedHead?.expensehead?.name || "",
            items: selectedHead?.supplyrequestitems?.map((item) => ({
              itemId: item?.item?.id,
              name: item?.item?.name,
              hsnCode: item?.item?.hsnCode,
              quantity: "", // Will be calculated later
              availableQty: parseFloat(item?.remainingQuantity) || 0, // Ensure numeric
              rate: item?.rate, // Stores the fixed Unit Rate
              gst: item?.gst,
              taxableAmount: "",
            })),
            itemsList: selectedHead?.supplyrequestitems || [],
          };
        }
        return section;
      })
    );
  };

  const addItem = (expenseIndex) => {
    setExpenseSections((prev) =>
      prev.map((section, i) => {
        if (i === expenseIndex) {
          return {
            ...section,
            items: [createNewItem(), ...section.items],
          };
        }
        return section;
      })
    );
  };

  const removeItem = (expenseIndex, itemIndex) => {
    setExpenseSections((prev) =>
      prev.map((section, i) => {
        if (i === expenseIndex) {
          return {
            ...section,
            items: section.items.filter((_, j) => j !== itemIndex),
          };
        }
        return section;
      })
    );
  };

  const handleItemChange = (expenseIndex, itemIndex, field, value) => {
    setExpenseSections((prev) =>
      prev.map((section, i) => {
        if (i === expenseIndex) {
          const newItems = section.items.map((item, j) => {
            if (j === itemIndex) {
              let updatedItem = { ...item };

              const originalItemDetails = section.itemsList.find(
                (k) => k.itemId === (field === "itemId" ? value : item.itemId)
              );
              const actualUnitRate = parseFloat(originalItemDetails?.rate || 0);
              const gst = parseFloat(item.gst || 0);
              const gstFactor = 1 + gst / 100;

              if (field === "itemId") {
                const remainingQty =
                  parseFloat(originalItemDetails?.remainingQuantity) || 0;

                updatedItem = {
                  ...item,
                  itemId: value,
                  name: originalItemDetails?.item?.name || "",
                  hsnCode: originalItemDetails?.item?.hsnCode || "--",
                  availableQty: remainingQty,
                  rate: actualUnitRate.toFixed(2),
                  gst: parseFloat(originalItemDetails?.gst || 0),
                  quantity: "",
                  taxableAmount: "",
                };
                return updatedItem;
              }

              updatedItem[field] = value;

              if (field === "taxableAmount") {
                const newTaxableAmountInput = parseFloat(value) || 0;
                let calculatedQuantity = 0;

                if (actualUnitRate > 0 && newTaxableAmountInput >= 0) {
                  calculatedQuantity = newTaxableAmountInput / actualUnitRate;
                }

                updatedItem.quantity = calculatedQuantity.toFixed(2);
                updatedItem.taxableAmount = value;
                updatedItem.rate = actualUnitRate.toFixed(2);
              }

              if (field !== "rate") {
                updatedItem.rate = actualUnitRate;
              }

              return updatedItem;
            }
            return item;
          });
          return { ...section, items: newItems };
        }
        return section;
      })
    );
  };

  const handleGTCFileChange = (index, event) => {
    const file = event.target.files[0];
    setState((prev) => {
      const updated = [...prev.gtc];
      updated[index].file = file;
      updated[index].existingId = null;
      return { ...prev, gtc: updated };
    });
    event.target.value = "";
  };

  const removeGTCFile = (docId, index) => {
    if (docId) {
      const API = `${apiUrl.delete_document}?documentId=${docId}`;
      callApi(API, { method: "GET" }).then((response) => {
        if (response?.status === true) {
          setState((prev) => {
            const updated = [...prev.gtc];
            updated[index].file = null;
            updated[index].existingId = null;
            return { ...prev, gtc: updated };
          });
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      });
    } else {
      setState((prev) => {
        const updated = [...prev.gtc];
        updated[index].file = null;
        return { ...prev, gtc: updated };
      });
    }
  };

  const poGstType = state?.purchaseDetails?.gstType;

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-itemsC-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.data ? "Update" : "Create"} Payment Ticket -
              Against PO
            </h1>
          </div>
        </div>
        <form id="againstPO" onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <Controller
                      name="siteId"
                      control={control}
                      rules={{ ...errorTypes.required("site") }}
                      render={({ field, fieldState }) => (
                        <SearchSelectInput
                          label="Site"
                          placeholder="Search Site"
                          value={state.siteName}
                          onSelect={(option) => {
                            field.onChange(option?.value);
                            setState((pre) => ({
                              ...pre,
                              siteId: option?.value,
                              siteName: option?.label,
                              purchaseId: "",
                              purchaseDetails: {},
                              financialYear: "--",
                            }));
                            setExpenseHeadList([]);
                            setValue("vendorId", "");
                            setValue("gstType", "");
                          }}
                          onBlur={field.onBlur}
                          errors={fieldState.error?.message}
                          options={
                            userDetails?.type === 2
                              ? state?.OandMSites
                              : state.assignedSites
                          }
                          onSearch={
                            userDetails?.type === 2
                              ? GetAllSitesList
                              : getAssignedSites
                          }
                          isLoading={state?.isLoadingSite}
                          showAddButton={false}
                          required={true}
                          disabled={
                            expenseSections.some((s) => s.items.length > 0) ||
                            location?.state?.data
                          }
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3 position-relative">
                    <label htmlFor="customerSearch" className="form-label">
                      Purchase Order<span className="text-danger">*</span>
                    </label>

                    <SearchSelectBox
                      value={state.purchaseId}
                      onChange={handleSearchChange}
                      fetchOptions={fetchPurchaseOrderList}
                      loading={state.purchaseLoading}
                      isAsync={true}
                      defaultFetch={state.siteId}
                      title={
                        !state.siteId
                          ? "Select a Site first"
                          : "Search Purchase Order"
                      }
                      error={errorState}
                      disable={!state.siteId || location?.state?.data}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Date<span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="date"
                      control={control}
                      rules={{
                        required: "This field is Required",
                      }}
                      defaultValue={moment().format("YYYY-MM-DD")}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="bDate"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.date?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Expense Month<span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="expenseMonth"
                      control={control}
                      rules={{ required: "Expense Month is required" }}
                      defaultValue=""
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="bDate"
                          format="MM/yyyy"
                          oneTap
                          placeholder="MM/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.expenseMonth?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Vendor<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register("vendorId", {
                        required: "vendor is required",
                      })}
                      placeholder="Please select PO"
                      disabled
                    />
                    <ErrorMessage message={errors?.vendorId?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      GST Type<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register("gstType", {
                        required: "gst type is required",
                      })}
                      placeholder="Please select PO"
                      disabled
                    />
                    <ErrorMessage message={errors?.gstType?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">Financial Year</label>
                    <input type="text" className="form-control" disabled
                      value={state.financialYear || "--"} />
                  </div>
                </div>

                {/* Supply Request Section*/}
                <div className="col-12">
                  <hr />
                  {isLoadingExpenseSections && (
                    <div className="d-flex w-100 justify-content-center align-items-center py-5">
                      <Spinner className="text-primary" />
                    </div>
                  )}
                  {expenseSections?.length > 0 &&
                    expenseSections.map((section, expenseIndex) => (
                      <div key={expenseIndex} className="card-box mb-3 card">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-12 col-md-6 col-lg-4">
                              <div className="form-group mb-3">
                                <label className="form-label">
                                  Expense Head
                                </label>
                                <select
                                  className="form-select form-control"
                                  value={section.expenseHeadId || ""}
                                  onChange={(e) =>
                                    handleExpenseHeadChange(expenseIndex, e)
                                  }
                                  disabled={!state.purchaseId}
                                >
                                  <option value="" disabled>
                                    Select Expense Head
                                  </option>
                                  {expenseHeadList?.length > 0 ? (
                                    expenseHeadList?.map((item) => (
                                      <option
                                        key={item?.expensehead?.id}
                                        value={item?.expensehead?.id}
                                        disabled={
                                          item?.supplyrequestitems?.length ===
                                          0 ||
                                          expenseSections.some(
                                            (expense) =>
                                              expense.expenseHeadId ===
                                              item?.expensehead?.id
                                          )
                                        }
                                      >
                                        {item?.expensehead?.name}
                                      </option>
                                    ))
                                  ) : (
                                    <option value="" disabled>
                                      No data available
                                    </option>
                                  )}
                                </select>
                              </div>
                            </div>

                            <div className="col-12">
                              <div className="d-flex justify-content-between align-items-center">
                                <h4 className="fs-3 rajdhani-semibold my-4">
                                  Item Details
                                </h4>
                                <button
                                  className="btn btn-outline-primary mx-2"
                                  type="button"
                                  onClick={() => addItem(expenseIndex)}
                                  disabled={!section.expenseHeadId}
                                >
                                  <PlusIcon /> Add Items
                                </button>
                              </div>

                              <div className="table-responsive">
                                <table className="table mt-3">
                                  <thead>
                                    <tr>
                                      <th style={{ width: "20%" }}>Item</th>
                                      <th style={{ width: "10%" }}>HSN Code</th>
                                      <th style={{ width: "10%" }}>Qty</th>
                                      <th style={{ width: "10%" }}>
                                        Unit Rate
                                      </th>
                                      <th style={{ width: "8%" }}>
                                        {poGstType === "CGST + SGST"
                                          ? "GST % (Total)"
                                          : "IGST %"}
                                      </th>
                                      {poGstType === "CGST + SGST" && (
                                        <>
                                          <th style={{ width: "8%" }}>CGST</th>
                                          <th style={{ width: "8%" }}>SGST</th>
                                        </>
                                      )}
                                      <th style={{ width: "12%" }}>
                                        Taxable Amount
                                      </th>
                                      <th style={{ width: "12%" }}>
                                        Total Amount
                                      </th>
                                      <th style={{ width: "6%" }}>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {!section.expenseHeadId ? (
                                      <tr>
                                        <td
                                          colSpan={
                                            poGstType === "CGST + SGST" ? 10 : 8
                                          }
                                          className="text-center text-warning"
                                        >
                                          Please Select Expense Head
                                        </td>
                                      </tr>
                                    ) : section.items.length === 0 ? (
                                      <tr>
                                        <td
                                          colSpan={
                                            poGstType === "CGST + SGST" ? 10 : 8
                                          }
                                          className="text-center text-danger"
                                        >
                                          No items added. Click "Add Items".
                                        </td>
                                      </tr>
                                    ) : (
                                      section.items.map((item, itemIndex) => {
                                        return (
                                          <tr key={itemIndex}>
                                            <td>
                                              <select
                                                className="form-select form-control"
                                                value={item.itemId || ""}
                                                onChange={(e) =>
                                                  handleItemChange(
                                                    expenseIndex,
                                                    itemIndex,
                                                    "itemId",
                                                    e.target.value
                                                  )
                                                }
                                              >
                                                <option value="" disabled>
                                                  Select Item
                                                </option>
                                                {section.itemsList?.map(
                                                  (option) => (
                                                    <option
                                                      key={option?.itemId}
                                                      value={option?.itemId}
                                                      disabled={section.items.some(
                                                        (i, idx) =>
                                                          i?.itemId ===
                                                          option?.itemId &&
                                                          idx !== itemIndex
                                                      )}
                                                    >
                                                      {option?.item?.name}{" "}
                                                      {`(HSN: ${option?.item?.hsnCode ||
                                                        "--"
                                                        })`}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            </td>
                                            <td>{item.hsnCode || "--"}</td>
                                            {/* Qty is CALCULATED and DISABLED */}
                                            <td>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  item?.quantity
                                                    ? item?.quantity
                                                    : ""
                                                }
                                                disabled={true}
                                              />
                                            </td>
                                            {/* Rate field is the FIXED UNIT RATE */}
                                            <td>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={item.rate || ""}
                                                disabled={true}
                                              />
                                            </td>
                                            {/* GST field (unchanged, disabled) */}
                                            <td>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={item.gst || ""}
                                                disabled
                                              />
                                            </td>
                                            {poGstType === "CGST + SGST" && (
                                              <>
                                                <td>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    value={
                                                      item.gst
                                                        ? (
                                                          parseFloat(
                                                            item.gst
                                                          ) / 2
                                                        ).toFixed(1) + "%"
                                                        : "0.0%"
                                                    }
                                                    disabled
                                                  />
                                                </td>
                                                <td>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    value={
                                                      item.gst
                                                        ? (
                                                          parseFloat(
                                                            item.gst
                                                          ) / 2
                                                        ).toFixed(1) + "%"
                                                        : "0.0%"
                                                    }
                                                    disabled
                                                  />
                                                </td>
                                              </>
                                            )}
                                            {/* Taxable Amount is the PRIMARY INPUT */}
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => e.target.blur()}
                                                className="form-control"
                                                min={0.01}
                                                step="any"
                                                value={item.taxableAmount || ""}
                                                onChange={(e) => {
                                                  let value = e.target.value;
                                                  if (
                                                    !/^\d*(\.\d{0,2})?$/.test(
                                                      value
                                                    )
                                                  )
                                                    return;
                                                  if (value.startsWith("."))
                                                    value = "0" + value;
                                                  handleItemChange(
                                                    expenseIndex,
                                                    itemIndex,
                                                    "taxableAmount",
                                                    value
                                                  );
                                                }}
                                                onBlur={(e) => {
                                                  const value = parseFloat(
                                                    e.target.value
                                                  );
                                                  if (!isNaN(value)) {
                                                    handleItemChange(
                                                      expenseIndex,
                                                      itemIndex,
                                                      "taxableAmount",
                                                      value.toFixed(2)
                                                    );
                                                  }
                                                }}
                                                disabled={!item.itemId}
                                                required
                                              />
                                            </td>
                                            {/* Total Amount (Calculated Display) */}
                                            <td>
                                              {formatAmount(
                                                (
                                                  parseFloat(
                                                    item.taxableAmount || 0
                                                  ) *
                                                  (1 +
                                                    parseFloat(item.gst || 0) /
                                                    100)
                                                ).toFixed(2)
                                              )}
                                            </td>

                                            {/* Action button (unchanged) */}
                                            <td>
                                              <button
                                                className="btn btn-outline-danger"
                                                type="button"
                                                onClick={() =>
                                                  removeItem(
                                                    expenseIndex,
                                                    itemIndex
                                                  )
                                                }
                                              >
                                                <DeleteIcon />
                                              </button>
                                            </td>
                                          </tr>
                                        );
                                      })
                                    )}
                                  </tbody>
                                </table>
                              </div>

                              {expenseSections.length > 1 && (
                                <div className="text-end">
                                  <button
                                    className="btn btn-outline-danger ms-3 py-2"
                                    type="button"
                                    onClick={() =>
                                      removeExpenseSection(expenseIndex)
                                    }
                                  >
                                    <DeleteIcon /> Remove Section
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  {/* <div className="col text-end">
                    <button
                      className="btn btn-outline-primary mx-2"
                      type="button"
                      onClick={addExpenseSection}
                      disabled={
                        !state.purchaseId || expenseHeadList.length === 0
                      }
                    >
                      <PlusIcon /> Add Section
                    </button>
                  </div> */}
                </div>

                {/* Grand Total Display */}
                {calculateGrandTotal() > 0 && (
                  <div className="col-12 mt-4">
                    <h3 className="text-success">
                      Grand Total:{" "}
                      {formatAmount(calculateGrandTotal().toFixed(2))}
                    </h3>
                  </div>
                )}

                {/* GTC File Uploader */}
                {state?.gtc?.length > 0 &&
                  state?.gtc?.map((item, index) => (
                    <FileUploader
                      key={item?.inputId}
                      label={item?.label}
                      inputId={item?.inputId}
                      file={item?.file}
                      onFileChange={(e) => handleGTCFileChange(index, e)}
                      onRemoveFile={() =>
                        removeGTCFile(item?.existingId, index)
                      }
                      isEdit={location?.state?.data}
                    />
                  ))}

                <div className="col-12 ">
                  <div className="form-group mb-3">
                    <label htmlFor="totalLeavePerMonth" className="form-label">
                      Description
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Controller
                      name="content"
                      control={control}
                      rules={
                        {
                          // required: "Description is required",
                        }
                      }
                      render={({ field }) => (
                        <div>
                          <CKEditor
                            {...field}
                            editor={ClassicEditor}
                            data={field.value || ""}
                            onChange={(event, editor) => {
                              field.onChange(editor.getData());
                            }}
                            config={{
                              toolbar: [
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "underline",
                                "strikethrough",
                                "|",
                                "fontColor",
                                "fontBackgroundColor",
                                "fontFamily",
                                "fontSize",
                                "alignment",
                                "|",
                                "link",
                                "bulletedList",
                                "numberedList",
                                "blockQuote",
                                "undo",
                                "redo",
                              ],
                              image: {
                                toolbar: [
                                  "imageStyle:alignLeft",
                                  "imageStyle:alignCenter",
                                  "imageStyle:alignRight",
                                  "|",
                                  "imageTextAlternative",
                                ],
                              },
                              height: "500px", // custom height for CKEditor
                            }}
                          />
                          <ErrorMessage message={errors?.content?.message} />
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  disabled={isLoading}
                  type="submit"
                  className="btn btn-primary px-5"
                >
                  {isLoading ? (
                    <Spinner />
                  ) : !location?.state?.data ? (
                    "Create"
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
